import styled from '@emotion/styled';

export const StyledActivationContent = styled.div(() => ({
    maxWidth: 585,
    margin: 'auto',
}));
